import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

import { css } from "glamor";

const baseUnit = 12;
/**
 * Branded Header for Login Page
 */
export const BrandedHeader = props => {
    const { logoUrl, textColor, title, subtitle, styles = {} } = props;
    const defaultStyles = {
        header: css({
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            letterSpacing: "0.1em",
            background: "white",
            paddingBottom: "${baseUnit * 2}px",
        }),
        h1: css({
            fontWeight: "bold",
            textShadow: "1px 3px 5px rgba(0,0,0,0.2)",
            fontSize: "3em",
            marginBottom: 0,
            lineHeight: 1,
            color: textColor,
        }),
        h2: css({
            fontWeight: 400,
            margin: 0,
        }),
        topLeftHeader: css({
            margin: `${2 * baseUnit}px`,
        }),
        logo: css({
            width: "240px",
            height: "40px",
            margin: `${2 * baseUnit}px ${baseUnit}px ${baseUnit}px`,
            backgroundImage: `url(${logoUrl})`,
            backgroundPosition: "center",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
        }),
    };

    R.forEach(key => {
        styles[key] = css(defaultStyles[key], styles[key]);
    }, R.keys(defaultStyles));

    return (
        <header {...styles.header}>
            <div {...styles.topLeftHeader}>
                {title && <h1 {...styles.h1}>{title}</h1>}
                {subtitle && <h2 {...styles.h2}>{subtitle}</h2>}
            </div>
            <div {...styles.logo} />
        </header>
    );
};

BrandedHeader.propTypes = {
    logoUrl: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    styles: PropTypes.object,
};
